import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
import { routerReducer as routing } from 'react-router-redux'
import alert from './alert'
import admin from './admin'
import modals from './modals'
import session from './session'
import properties from './properties'
import user from './user'
import { LOGOUT } from '../constants'

const reducers = combineReducers({
  form,
  user,
  alert,
  admin,
  modals,
  routing,
  session,
  properties
})

export default function(state, action) {
  if (action.type === LOGOUT) {
    return reducers(undefined, action)
  }
  return reducers(state, action)
}



// WEBPACK FOOTER //
// ./src/reducers/index.js